import React, { useState } from 'react';
import CheckboxInput from '../checkbox/Checkbox';
import Skeleton from "react-loading-skeleton";

const ModalCheckbox = ({ label, checked, setChecked, disabled = false, loading = false }) => {
    return (
        loading ?
            <Skeleton height={40} width={150} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
            :
            <div className={`modalsCheckboxWrap ${checked && 'modalsCheckboxActive'}`}>
                <CheckboxInput label={label} checked={checked} setChecked={(val) => !disabled && setChecked(val)} disabled={disabled} />
                {/* <CheckboxInput label={label} checked={checked} /> */}

            </div>
    )
}

export default ModalCheckbox;

